import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type Notice = { notice: string | null; setNotice: (notice: string | null) => void };

/** A one-line problem the composer shows until the next edit ("Couldn't add …"). */
const NoticeContext = createContext<Notice | null>(null);

const NO_NOTICE: Notice = { notice: null, setNotice: () => {} };

function OwnNotice({ children }: { children: ReactNode }) {
  const [notice, setNoticeState] = useState<string | null>(null);
  const setNotice = useCallback((next: string | null) => setNoticeState(next), []);
  const value = useMemo(() => ({ notice, setNotice }), [notice, setNotice]);
  return <NoticeContext.Provider value={value}>{children}</NoticeContext.Provider>;
}

/** One inside another reuses the outer: a drop beside the chat (the lip's) tells its composer. */
export function NoticeProvider({ children }: { children: ReactNode }) {
  const outer = useContext(NoticeContext);
  return outer ? <>{children}</> : <OwnNotice>{children}</OwnNotice>;
}

export const useNotice = () => useContext(NoticeContext) ?? NO_NOTICE;
